import React from "react";
import * as FaIcons from "react-icons/fa";

export default function Home() {
  return (
    <section className="section-home">
      <div className="container">
        <div className="text-home">
          <p className="subtitle">Hello, I am</p>
          <h1 className="name">Muhamad Fathur Rahman</h1>
          <p className="subtitle">Front-end Developer.</p>
          <div className="socmed-list my-8">
            <ul>
              <li className="item">
                <a href="https://github.com/muhfathurrah16/" target="_blank">
                  <FaIcons.FaGithub size={"2rem"} />
                </a>
              </li>
              <li className="item">
                <a
                  href="https://linkedin.com/in/muhfathurrah16/"
                  target="_blank"
                >
                  <FaIcons.FaLinkedinIn size={"2rem"} />
                </a>
              </li>
              <li className="item">
                <a href="	https://medium.com/@muhammadfathur88/" target="_blank">
                  <FaIcons.FaMediumM size={"2rem"} />
                </a>
              </li>
              <li className="item">
                <a href="https://instagram.com/muhfathurrah16/" target="_blank">
                  <FaIcons.FaInstagram size={"2rem"} />
                </a>
              </li>
              <li className="item">
                <a href="mailto:muhammadfathur88@gmail.com">
                  <FaIcons.FaGoogle size={"2rem"} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
